import { render, staticRenderFns } from "./VideoPlayerDialog.vue?vue&type=template&id=3195f02a&scoped=true"
import script from "./VideoPlayerDialog.vue?vue&type=script&lang=js"
export * from "./VideoPlayerDialog.vue?vue&type=script&lang=js"
import style0 from "./VideoPlayerDialog.vue?vue&type=style&index=0&id=3195f02a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3195f02a",
  null
  
)

export default component.exports